<template>
	<div >
		<div >
			<div>
				<div id="form_law" >
					<div >
						<div >
							<el-input
									readonly="readonly"
									type="textarea" autosize resize='none'
									:disabled="disabled"
									@focus="getGheckUser(0)"
									v-model="names.authperson "
									placeholder="请选择人员"
							/>
						</div>
					</div>
				</div>
				<el-dialog custom-class='treeDia' :visible.sync="show" :append-to-body='true' :close-on-click-modal="false"
						   width="90%" style="{height:50%}" title="选择人员" top='8vh'>
					<checkusertree :user="user"
								   v-if="show"
								   :dataUrl="dataUrl"
								   :modelName="modelName"
								   :multiple="multiple"
								   :zylb="zylb"
								   :xgfzy="xgfzy"
								   :showDataIdTemp="names.authPersonId"
								   :showDataTemp="names.authperson"
								   :showFlag="names.authPersonFlag"
                   				   :label="label"/>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import checkusertree from './often-checkusertree.vue';
	export default {
		name: "c-personnel",
		props:{
			disabled: [Boolean,Number],
			defaultValue: [String,Number,Object],
			dataUrl: String,
			modelName:String,
			multiple: {               // 是否多选
				type: Boolean,
				default: false
			},
	  		label: String,
	  		zylb: String,
	  		xgfzy: String
    },
		components: {
			checkusertree
		},
		data() {
			return {
				baseUrl: sessionStorage.getItem("baseURL"),
				names: {
					authperson: null,
					authPersonId: null,
					authPersonFlag: null
				},
				show: false,
				user: null,
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			//选择人
			getGheckUser(user) {
				if(!this.disabled){
					this.show = true;
					this.user = user;
				}
			},

			// 根据先择人员给相应的人员赋值
			setTreePeople(userid, username,relatedId, user, flag) {
				if (user === 0) {
					// this.names.authperson = username;
					if(this.label == '作业人'){
						this.$emit("changeValue",{value:
								[{username:username,userid:userid,userflag:flag}],relatedId:relatedId})
					}else{
						this.$emit("changeValue",{value:
								[{username:username,userid:userid}],relatedId:relatedId})
					}
				}
			},
		},

		watch: {
			defaultValue: {
				handler(val){
					if(val){
						let obj = JSON.parse(val);
						this.names.authperson = obj[0]?.username;
						this.names.authPersonId = obj[0]?.userid;
						this.names.authPersonFlag = obj[0]?.userflag;
					}else{
						this.names.authperson = ''
						this.names.authPersonId = ''
						this.names.authPersonFlag = '';
					}
				},
				immediate: true,
				deep: true
			}
		},
	}
</script>

<style>
	.treeDia .el-dialog__body{
		max-height: 80vh;
		overflow: auto;
	}
</style>
